import React, { useRef } from 'react'
import { message } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useHistory, useParams } from 'react-router-dom'
import { useLocalization } from '@contexts/LocalizationContext'
import FormComponent from './Form'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const Create = () => {
  const { t } = useLocalization()
  const history = useHistory()
  const fetchRef = useRef(null)
  const params = useParams()
  const handleSubmit = async (data) => {
    try {
      await client.patch(`/article/${params.id}`, data)
      message.success('สำเร็จ')
      history.push('/articles')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }
  const fetch = async () => {
    const data = await client
      .get(`/article/${params.id}`)
      .then((res) => res.data)
    return data
  }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {(data) => (
        <PageLayout title={t('article.editScreen.title')} extra={[]}>
          <FormComponent handleSubmit={handleSubmit} defaultValues={data} />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Create
